import { useState, Fragment, useEffect } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import MainPageMenu from "./MainPageMenu";
import { toast } from "react-toastify";
import { checkResponseData, customToastify, checkErrorMessage } from "../utils/utils";
import OneBoxDetails from "./OneBoxDetails/OneBoxDetails";
import Box from "@mui/material/Box";
import CreateNewBox from "./Boxs/CreateNewBox";
import { Link } from "react-router-dom";
import { Typography, Button, Divider } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import AlertDeleteBox from "./AlertDeleteBox";
import { deleteBoxApi } from "../../services/leitnerApi";
import Paper from '@mui/material/Paper';
import PhoneInput from 'react-phone-input-2'
import Input from '@mui/material/Input';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import FilledInput from '@mui/material/FilledInput';
import { loginApi } from "../../services/authApi"


export default function LoginMenu({ handleUserTypes, CheckUserSignIn }) {

  const [showPassword, setShowPassword] = useState(false);
  const [loginInfo, setLoginInfo] = useState();
  const [typeLogin, setTypeLogin] = useState("username");
  const [password, setPassword] = useState("username");



  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => { event.preventDefault() };

  const handleLoginSubmit = async () => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      const response = await loginApi({ loginInfo, password })
      const resData = checkResponseData(response)
      if (resData["success"]) {
        localStorage.setItem("token", JSON.stringify(response.data.token));
        localStorage.setItem("refreshToken", JSON.stringify(response.data.refreshToken));
        handleUserTypes(resData["data"]["data"][0]["type_user"])
        CheckUserSignIn()
        // setUserName(resData["data"]["data"][0]["userName"])
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        // setTimeout(() => {
        //   handleCloseSignInBox(false);
        // }, 1000)
      }
    } catch (error) {
      const errData = checkErrorMessage(error)
      toast.update(toastMsg, { render: errData["titles"] || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
      // customToastify("error", errData["titles"]);
      console.error(error);
    }
  };

  return (
    <Paper sx={{ m: 2, p: 2 }} variant="outlined">
      <Typography sx={{ textAlign: "right" }} >
        <Link sx={{ textAlign: "center" }} to="/" style={{ textDecoration: "none" }}>
          <Button
            sx={{ p: 0.1, mx: 1, mt: 0, textAlign: "center" }}
            variant="contained"
            color="info"
            size="small"
            endIcon={<KeyboardBackspaceIcon />}
          >
            بازگشت به صفحه اصلی
          </Button>
        </Link>          </Typography>
      <Typography sx={{ textAlign: "center" }} >
        لطفا ابتدا لاگین کنید
      </Typography>
      <Box
        style={{ textAlign: "center", width: "fit-content" }}
      >
        <RadioGroup
          row
          name="row-radio-buttons-group"
          onChange={(e) => { setTypeLogin(e.target.value) }}
        >
          <FormControlLabel checked={typeLogin == "username"} value="username" control={<Radio />} label="ایمیل/نام کاربری" />
          <FormControlLabel value="email" control={<Radio />} label="تلفن" />
        </RadioGroup>
        {typeLogin == "username" ? <TextField onChange={(e) => { setLoginInfo(e.target.value); }} id="outlined-basic" label="ایمیل/نام کاربری" variant="outlined" size="small" /> :
          <PhoneInput
            isValid={(value, country) => {
              if (value.match(/12345/)) {
                return "شماره نامعتبر";
              } else if (value.match(/1234/)) {
                return false;
              } else {
                return true;
              }
            }}
            placeholder="شماره تلفن"
            countryCodeEditable={false}
            inputStyle={{ color: 'black', width: "220px" }}
            containerStyle={{ color: 'black', direction: "ltr" }}
            buttonStyle={{}}
            value={loginInfo}
            //   dropdownStyle={{height:'50px'}}
            country={'ir'}
            enableSearch={true}
            onChange={(phone, dialCode) => {
              setLoginInfo(phone);
            }}
          />}
      </Box>
      <FormControl sx={{ m: 1 }} variant="filled">
        <InputLabel htmlFor="filled-adornment-password">کلمه عبور</InputLabel>
        <FilledInput
          size="small"
          id="filled-adornment-password"
          type={showPassword ? 'text' : 'password'}
          onChange={(e) => {
            setPassword(e.target.value)
          }}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
      <br />
      <Button
        type="submit"
        variant="contained"
        sx={{ m: 1 }}
        onClick={handleLoginSubmit}
      >
        ورود
      </Button>
    </Paper>
  );
}
